var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnterprises(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 70,
    viewBox: "0 0 68 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9121 0C41.9121 0 41.9121 0.546957 41.9121 1.47826C41.9121 2.40957 42.2817 3.38522 43.3904 4.43478C45.046 5.98696 47.8252 6.72609 47.8252 8.86957V16.2609",
    stroke: "#23262B",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3907 13.3043V19.2174C43.3907 20.9617 39.7394 22.1739 34.5211 22.1739C29.4359 22.1739 21.2168 21.5826 21.2168 19.2174C21.2168 15.9948 21.2168 8.86957 21.2168 8.86957C21.2168 6.14957 24.1733 4.30174 24.1733 2.95652C24.1733 1.6113 24.1733 0 24.1733 0",
    stroke: "#23262B",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0872 44.3478V68H3.47852V44.3478",
    stroke: "#23262B",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.653 45.826H18.2617V54.6956H25.653V45.826Z",
    stroke: "#23262B",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3034 45.826H41.9121V54.6956H49.3034V45.826Z",
    stroke: "#23262B",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.218 16.2609H19.7397C18.1136 16.2609 16.7832 17.5913 16.7832 19.2174V26.6087",
    stroke: "#23262B",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3906 16.2609H46.3471C47.9732 16.2609 49.3037 17.5913 49.3037 19.2174V26.6087",
    stroke: "#23262B",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9132 48.7826H25.6523",
    stroke: "#23262B",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2609 48.7826H15.3043C10.367 48.7826 2 46.1069 2 41.3913V26.6086H65.5652V41.3913C65.5652 46.1069 57.1983 48.7826 52.2609 48.7826H49.3043",
    stroke: "#23262B",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterprises);
export default __webpack_public_path__ + "static/media/enterprises.811dbabfb17fdd62498864e90608fbae.svg";
export { ForwardRef as ReactComponent };